<form class="filter" #formElement [formGroup]="form">
    <mat-form-field class="medium-width">
        <input matInput autocomplete="off" formControlName="DateFrom" [matDatepicker]="pickerFrom" placeholder="Fecha desde" required />
        <mat-datepicker-toggle matSuffix [for]="pickerFrom"></mat-datepicker-toggle>
        <mat-datepicker #pickerFrom></mat-datepicker>
    </mat-form-field>

    <mat-form-field class="medium-width">
        <input matInput autocomplete="off" formControlName="DateTo" [matDatepicker]="pickerTo" placeholder="Fecha hasta" required />
        <mat-datepicker-toggle matSuffix [for]="pickerTo"></mat-datepicker-toggle>
        <mat-datepicker #pickerTo></mat-datepicker>
    </mat-form-field>

    <mat-form-field class="medium-width">
        <input matInput autocomplete="off" formControlName="Protocol" placeholder="Protocolo" />
    </mat-form-field>

    <mat-form-field class="medium-width">
        <input type="text" matInput placeholder="Práctica" formControlName="PracticeRegion" [matAutocomplete]="autPracticeRegion" />
        <mat-autocomplete #autPracticeRegion="matAutocomplete" [displayWith]="filterCompletePracticeRegions.displayFn">
            <mat-option *ngFor="let practiceRegion of filteredPracticeRegionsOptions | async" [value]="practiceRegion">
                {{ practiceRegion.Name }}
            </mat-option>
        </mat-autocomplete>
    </mat-form-field>

    <mat-form-field class="medium-width">
        <input type="text" matInput placeholder="Región informe" formControlName="ReportRegion" [matAutocomplete]="autReportRegion" />
        <mat-autocomplete #autReportRegion="matAutocomplete" [displayWith]="filterCompleteReportRegions.displayFn">
            <mat-option *ngFor="let reportRegion of filteredReportRegionsOptions | async" [value]="reportRegion">
                {{ reportRegion.Name }}
            </mat-option>
        </mat-autocomplete>
    </mat-form-field>

    <mat-form-field class="medium-width">
        <input type="text" matInput placeholder="Médico informante" formControlName="ReportingPhysician" [matAutocomplete]="autReportingPhysician" />
        <mat-autocomplete #autReportingPhysician="matAutocomplete" [displayWith]="filterCompleteReportingPhysicians.displayFn">
            <mat-option *ngFor="let physician of filteredReportingPhysiciansOptions | async" [value]="physician">
                {{ physician.Name }}
            </mat-option>
        </mat-autocomplete>
    </mat-form-field>

    <mat-form-field class="medium-width">
        <input type="text" matInput placeholder="Especialidad" formControlName="Specialty" [matAutocomplete]="autSpecialty" />
        <mat-autocomplete #autSpecialty="matAutocomplete" [displayWith]="filterCompleteSpecialties.displayFn">
            <mat-option *ngFor="let specialty of filteredSpecialtiesOptions | async" [value]="specialty">
                {{ specialty.Name }}
            </mat-option>
        </mat-autocomplete>
    </mat-form-field>
</form>